module.exports = __webpack_public_path__ + "static/media/wide.977683a6.jpg";